'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleUGCPermalink = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseIcons = require('@bibliocommons/base-icons');

var _privacyToggle = require('../../privacy-toggle');

var _privacyToggle2 = _interopRequireDefault(_privacyToggle);

require('../styles/SimpleUGCPermalink.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getIconForUGC = function getIconForUGC(ugcType) {
  switch (ugcType) {
    case 'video':
      return _react2.default.createElement(_baseIcons.Video, null);
    case 'comment':
      return _react2.default.createElement(_baseIcons.Comment, null);
    case 'quotation':
      return _react2.default.createElement(_baseIcons.Quotation, null);
    case 'summary':
      return _react2.default.createElement(_baseIcons.Summary, null);
    default:
      return null;
  }
};

var SimpleUGCPermalink = exports.SimpleUGCPermalink = function (_BcReactComponent) {
  _inherits(SimpleUGCPermalink, _BcReactComponent);

  function SimpleUGCPermalink() {
    _classCallCheck(this, SimpleUGCPermalink);

    return _possibleConstructorReturn(this, (SimpleUGCPermalink.__proto__ || Object.getPrototypeOf(SimpleUGCPermalink)).apply(this, arguments));
  }

  _createClass(SimpleUGCPermalink, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          bibId = _props.bibId,
          isPrivate = _props.isPrivate,
          userContentId = _props.userContentId,
          ugcType = _props.ugcType,
          handlePrivacyToggle = _props.handlePrivacyToggle;

      var messageKey = isPrivate ? 'private_' + ugcType + '_exists' : ugcType + '_exists';
      return _react2.default.createElement(
        'div',
        { className: 'well permalink cp-simple-ugc-permalink' },
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-sm-1' },
            getIconForUGC(ugcType)
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-sm-11' },
            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
              id: messageKey,
              values: {
                bibId: bibId,
                userContentId: userContentId
              } }),
            _react2.default.createElement(_privacyToggle2.default, { bibId: bibId, isPrivate: isPrivate, handlePrivacyToggle: handlePrivacyToggle, showLabel: true })
          )
        )
      );
    }
  }]);

  return SimpleUGCPermalink;
}(_baseBcReactComponent2.default);

SimpleUGCPermalink.propTypes = {
  bibId: _react.PropTypes.number.isRequired,
  isPrivate: _react.PropTypes.bool.isRequired,
  handlePrivacyToggle: _react.PropTypes.func.isRequired,
  userContentId: _react.PropTypes.number.isRequired,
  ugcType: _react.PropTypes.string.isRequired
};

exports.default = SimpleUGCPermalink;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/shared/ugc-editors/lib/components/simple-ugc-permalink/components/SimpleUGCPermalink.js
// module id = 1045
// module chunks = 4